module.exports = __webpack_public_path__ + "comments/production/img/avatar_female.c22aead.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar_female.jpg
// module id = si2X
// module chunks = 0